/** @hidden */
export var created = 'create';
/** @hidden */

export var destroyed = 'destroy';
/** @hidden */

export var load = 'load';
/** @hidden */

export var rowDataBound = 'rowDataBound';
/** @hidden */

export var queryCellInfo = 'queryCellInfo';
/** @hidden */

export var headerCellInfo = 'headerCellInfo';
/** @hidden */

export var actionBegin = 'actionBegin';
/** @hidden */

export var actionComplete = 'actionComplete';
/** @hidden */

export var actionFailure = 'actionFailure';
/** @hidden */

export var dataBound = 'dataBound';
/** @hidden */

export var rowSelecting = 'rowSelecting';
/** @hidden */

export var rowSelected = 'rowSelected';
/** @hidden */

export var rowDeselecting = 'rowDeselecting';
/** @hidden */

export var rowDeselected = 'rowDeselected';
/** @hidden */

export var cellSelecting = 'cellSelecting';
/** @hidden */

export var cellSelected = 'cellSelected';
/** @hidden */

export var cellDeselecting = 'cellDeselecting';
/** @hidden */

export var cellDeselected = 'cellDeselected';
/** @hidden */

export var columnSelecting = 'columnSelecting';
/** @hidden */

export var columnSelected = 'columnSelected';
/** @hidden */

export var columnDeselecting = 'columnDeselecting';
/** @hidden */

export var columnDeselected = 'columnDeselected';
/** @hidden */

export var columnDragStart = 'columnDragStart';
/** @hidden */

export var columnDrag = 'columnDrag';
/** @hidden */

export var columnDrop = 'columnDrop';
/** @hidden */

export var rowDragStartHelper = 'rowDragStartHelper';
/** @hidden */

export var rowDragStart = 'rowDragStart';
/** @hidden */

export var rowDrag = 'rowDrag';
/** @hidden */

export var rowDrop = 'rowDrop';
/** @hidden */

export var beforePrint = 'beforePrint';
/** @hidden */

export var printComplete = 'printComplete';
/** @hidden */

export var detailDataBound = 'detailDataBound';
/** @hidden */

export var toolbarClick = 'toolbarClick';
/** @hidden */

export var batchAdd = 'batchAdd';
/** @hidden */

export var batchCancel = 'batchCancel';
/** @hidden */

export var batchDelete = 'batchDelete';
/** @hidden */

export var beforeBatchAdd = 'beforeBatchAdd';
/** @hidden */

export var beforeBatchDelete = 'beforeBatchDelete';
/** @hidden */

export var beforeBatchSave = 'beforeBatchSave';
/** @hidden */

export var beginEdit = 'beginEdit';
/** @hidden */

export var cellEdit = 'cellEdit';
/** @hidden */

export var cellSave = 'cellSave';
/** @hidden */

export var cellSaved = 'cellSaved';
/** @hidden */

export var endAdd = 'endAdd';
/** @hidden */

export var endDelete = 'endDelete';
/** @hidden */

export var endEdit = 'endEdit';
/** @hidden */

export var recordDoubleClick = 'recordDoubleClick';
/** @hidden */

export var recordClick = 'recordClick';
/** @hidden */

export var beforeDataBound = 'beforeDataBound';
/** @hidden */

export var beforeOpenColumnChooser = 'beforeOpenColumnChooser';
/** @hidden */

export var beforeOpenAdaptiveDialog = 'beforeOpenAdaptiveDialog';
/** @hidden */

export var resizeStart = 'resizeStart';
/** @hidden */

export var onResize = 'resizing';
/** @hidden */

export var resizeStop = 'resizeStop';
/** @hidden */

export var checkBoxChange = 'checkBoxChange';
/** @hidden */

export var beforeCopy = 'beforeCopy';
/** @hidden */

export var beforePaste = 'beforePaste';
/** @hidden */

export var beforeAutoFill = 'beforeAutoFill';
/** @hidden */

export var filterChoiceRequest = 'filterchoicerequest';
/** @hidden */

export var filterAfterOpen = 'filterafteropen';
/** @hidden */

export var filterBeforeOpen = 'filterbeforeopen';
/** @hidden */

export var filterSearchBegin = 'filtersearchbegin';
/** @hidden */

export var commandClick = 'commandClick';
/** @hidden */

export var exportGroupCaption = 'exportGroupCaption';
/** @hidden */

export var lazyLoadGroupExpand = 'lazyLoadGroupExpand';
/** @hidden */

export var lazyLoadGroupCollapse = 'lazyLoadGroupCollapse';
/**
 * Specifies grid internal events
 */

/** @hidden */

export var initialLoad = 'initial-load';
/** @hidden */

export var initialEnd = 'initial-end';
/** @hidden */

export var dataReady = 'data-ready';
/** @hidden */

export var contentReady = 'content-ready';
/** @hidden */

export var uiUpdate = 'ui-update';
/** @hidden */

export var onEmpty = 'on-empty';
/** @hidden */

export var inBoundModelChanged = 'inbound-model-changed';
/** @hidden */

export var modelChanged = 'model-changed';
/** @hidden */

export var colGroupRefresh = 'colgroup-refresh';
/** @hidden */

export var headerRefreshed = 'header-refreshed';
/** @hidden */

export var pageBegin = 'paging-begin';
/** @hidden */

export var pageComplete = 'paging-complete';
/** @hidden */

export var sortBegin = 'sorting-begin';
/** @hidden */

export var sortComplete = 'sorting-complete';
/** @hidden */

export var filterBegin = 'filtering-begin';
/** @hidden */

export var filterComplete = 'filtering-complete';
/** @hidden */

export var searchBegin = 'searching-begin';
/** @hidden */

export var searchComplete = 'searching-complete';
/** @hidden */

export var reorderBegin = 'reorder-begin';
/** @hidden */

export var reorderComplete = 'reorder-complete';
/** @hidden */

export var rowDragAndDropBegin = 'rowdraganddrop-begin';
/** @hidden */

export var rowDragAndDropComplete = 'rowdraganddrop-complete';
/** @hidden */

export var groupBegin = 'grouping-begin';
/** @hidden */

export var groupComplete = 'grouping-complete';
/** @hidden */

export var ungroupBegin = 'ungrouping-begin';
/** @hidden */

export var ungroupComplete = 'ungrouping-complete';
/** @hidden */

export var groupAggregates = 'group-aggregates';
/** @hidden */

export var refreshFooterRenderer = 'refresh-footer-rendered';
/** @hidden */

export var refreshAggregateCell = 'refresh-aggregate-cell';
/** @hidden */

export var refreshAggregates = 'refresh-aggregates';
/** @hidden */

export var rowSelectionBegin = 'rowselecting';
/** @hidden */

export var rowSelectionComplete = 'rowselected';
/** @hidden */

export var columnSelectionBegin = 'columnselecting';
/** @hidden */

export var columnSelectionComplete = 'columnselected';
/** @hidden */

export var cellSelectionBegin = 'cellselecting';
/** @hidden */

export var cellSelectionComplete = 'cellselected';
/** @hidden */

export var beforeCellFocused = 'beforecellfocused';
/** @hidden */

export var cellFocused = 'cellfocused';
/** @hidden */

export var keyPressed = 'key-pressed';
/** @hidden */

export var click = 'click';
/** @hidden */

export var destroy = 'destroy';
/** @hidden */

export var columnVisibilityChanged = 'column-visible-changed';
/** @hidden */

export var scroll = 'scroll';
/** @hidden */

export var columnWidthChanged = 'column-width-changed';
/** @hidden */

export var columnPositionChanged = 'column-position-changed';
/** @hidden */

export var rowDragAndDrop = 'row-drag-and-drop';
/** @hidden */

export var rowsAdded = 'rows-added';
/** @hidden */

export var rowsRemoved = 'rows-removed';
/** @hidden */

export var columnDragStop = 'column-drag-stop';
/** @hidden */

export var headerDrop = 'header-drop';
/** @hidden */

export var dataSourceModified = 'datasource-modified';
/** @hidden */

export var refreshComplete = 'refresh-complete';
/** @hidden */

export var refreshVirtualBlock = 'refresh-virtual-block';
/** @hidden */

export var dblclick = 'dblclick';
/** @hidden */

export var toolbarRefresh = 'toolbar-refresh';
/** @hidden */

export var bulkSave = 'bulk-save';
/** @hidden */

export var autoCol = 'auto-col';
/** @hidden */

export var tooltipDestroy = 'tooltip-destroy';
/** @hidden */

export var updateData = 'update-data';
/** @hidden */

export var editBegin = 'edit-begin';
/** @hidden */

export var editComplete = 'edit-complete';
/** @hidden */

export var addBegin = 'add-begin';
/** @hidden */

export var addComplete = 'add-complete';
/** @hidden */

export var saveComplete = 'save-complete';
/** @hidden */

export var deleteBegin = 'delete-begin';
/** @hidden */

export var deleteComplete = 'delete-complete';
/** @hidden */

export var preventBatch = 'prevent-batch';
/** @hidden */

export var dialogDestroy = 'dialog-destroy';
/** @hidden */

export var crudAction = 'crud-Action';
/** @hidden */

export var addDeleteAction = 'add-delete-Action';
/** @hidden */

export var destroyForm = 'destroy-form';
/** @hidden */

export var doubleTap = 'double-tap';
/** @hidden */

export var beforeExcelExport = 'beforeExcelExport';
/** @hidden */

export var excelExportComplete = 'excelExportComplete';
/** @hidden */

export var excelQueryCellInfo = 'excelQueryCellInfo';
/** @hidden */

export var excelHeaderQueryCellInfo = 'excelHeaderQueryCellInfo';
/** @hidden */

export var exportDetailDataBound = 'exportdetaildatabound';
/** @hidden */

export var beforePdfExport = 'beforePdfExport';
/** @hidden */

export var pdfExportComplete = 'pdfExportComplete';
/** @hidden */

export var pdfQueryCellInfo = 'pdfQueryCellInfo';
/** @hidden */

export var pdfHeaderQueryCellInfo = 'pdfHeaderQueryCellInfo';
/** @hidden */

export var accessPredicate = 'access-predicate';
/** @hidden */

export var contextMenuClick = 'contextMenuClick';
/** @hidden */

export var freezeRender = 'freezerender';
/** @hidden */

export var freezeRefresh = 'freezerefresh';
/** @hidden */

export var contextMenuOpen = 'contextMenuOpen';
/** @hidden */

export var columnMenuClick = 'columnMenuClick';
/** @hidden */

export var columnMenuOpen = 'columnMenuOpen';
/** @hidden */

export var filterOpen = 'filterOpen';
/** @hidden */

export var filterDialogCreated = 'filterDialogCreated';
/** @hidden */

export var filterMenuClose = 'filter-menu-close';
/** @hidden */

export var initForeignKeyColumn = 'initForeignKeyColumn';
/** @hidden */

export var getForeignKeyData = 'getForeignKeyData';
/** @hidden */

export var generateQuery = 'generateQuery';
/** @hidden */

export var showEmptyGrid = 'showEmptyGrid';
/** @hidden */

export var foreignKeyData = 'foreignKeyData';
/** @hidden */

export var columnDataStateChange = 'columnDataStateChange';
/** @hidden */

export var dataStateChange = 'dataStateChange';
/** @hidden */

export var dataSourceChanged = 'dataSourceChanged';
/** @hidden */

export var rtlUpdated = 'rtl-updated';
/** @hidden */

export var beforeFragAppend = 'beforeFragAppend';
/** @hidden */

export var frozenHeight = 'frozenHeight';
/** @hidden */

export var textWrapRefresh = 'textWrapRefresh';
/** @hidden */

export var recordAdded = 'recordAdded';
/** @hidden */

export var cancelBegin = 'cancel-Begin';
/** @hidden */

export var editNextValCell = 'editNextValCell';
/** @hidden */

export var hierarchyPrint = 'hierarchyprint';
/** @hidden */

export var expandChildGrid = 'expandchildgrid';
/** @hidden */

export var printGridInit = 'printGrid-Init';
/** @hidden */

export var exportRowDataBound = 'export-RowDataBound';
/** @hidden */

export var exportDataBound = 'export-DataBound';
/** @hidden */

export var rowPositionChanged = 'row-position-changed';
/** @hidden */

export var columnChooserOpened = 'columnChooserOpened';
/** @hidden */

export var batchForm = 'batchedit-form';
/** @hidden */

export var beforeStartEdit = 'edit-form';
/** @hidden */

export var beforeBatchCancel = 'before-batch-cancel';
/** @hidden */

export var batchEditFormRendered = 'batcheditform-rendered';
/** @hidden */

export var partialRefresh = 'partial-refresh';
/** @hidden */

export var beforeCustomFilterOpen = 'beforeCustomFilterOpen';
/** @hidden */

export var selectVirtualRow = 'select-virtual-Row';
/** @hidden */

export var columnsPrepared = 'columns-prepared';
/** @hidden */

export var cBoxFltrBegin = 'cbox-filter-begin';
/** @hidden */

export var cBoxFltrComplete = 'cbox-filter-complete';
/** @hidden */

export var fltrPrevent = 'filter-Prevent';
/** @hidden */

export var beforeFltrcMenuOpen = 'before-filter-cmenu-open';
/** @hidden */

export var valCustomPlacement = 'validation-custom-placement';
/** @hidden */

export var filterCboxValue = 'filter-cbox-value';
/** @hidden */

export var componentRendered = 'component-rendered';
/** @hidden */

export var restoreFocus = 'restore-Focus';
/** @hidden */

export var detailStateChange = 'detail-state-change';
/** @hidden */

export var detailIndentCellInfo = 'detail-indentcell-info';
/** @hidden */

export var virtaulKeyHandler = 'virtaul-key-handler';
/** @hidden */

export var virtaulCellFocus = 'virtaul-cell-focus';
/** @hidden */

export var virtualScrollEditActionBegin = 'virtual-scroll-edit-action-begin';
/** @hidden */

export var virtualScrollEditSuccess = 'virtual-scroll-edit-success';
/** @hidden */

export var virtualScrollEditCancel = 'virtual-scroll-edit-cancel';
/** @hidden */

export var virtualScrollEdit = 'virtual-scroll-edit';
/** @hidden */

export var refreshVirtualCache = 'refresh-virtual-cache';
/** @hidden */

export var editReset = 'edit-reset';
/** @hidden */

export var virtualScrollAddActionBegin = 'virtual-scroll-add-action-begin';
/** @hidden */

export var getVirtualData = 'get-virtual-data';
/** @hidden */

export var refreshInfiniteModeBlocks = 'refresh-infinite-mode-blocks';
/** @hidden */

export var resetInfiniteBlocks = 'reset-infinite-blocks';
/** @hidden */

export var infiniteScrollHandler = 'infinite-scroll-handler';
/** @hidden */

export var infinitePageQuery = 'infinite-page-query';
/** @hidden */

export var infiniteShowHide = 'infinite-show-hide';
/** @hidden */

export var appendInfiniteContent = 'append-infinite-content';
/** @hidden */

export var removeInfiniteRows = 'remove-infinite-rows';
/** @hidden */

export var setInfiniteCache = 'set-infinite-cache';
/** @hidden */

export var infiniteEditHandler = 'infinite-edit-handler';
/** @hidden */

export var initialCollapse = 'initial-collapse';
/** @hidden */

export var getAggregateQuery = 'get-aggregate-query';
/** @hidden */

export var closeFilterDialog = 'close-filter-dialog';
/** @hidden */

export var columnChooserCancelBtnClick = 'columnChooserCancelBtnClick';
/** @hidden */

export var getFilterBarOperator = 'get-filterbar-operator';
/** @hidden */

export var resetColumns = 'reset-columns';
/** @hidden */

export var pdfAggregateQueryCellInfo = 'pdfAggregateQueryCellInfo';
/** @hidden */

export var excelAggregateQueryCellInfo = 'excelAggregateQueryCellInfo';
/** @hidden */

export var setGroupCache = 'group-cache';
/** @hidden */

export var lazyLoadScrollHandler = 'lazy-load-scroll-handler';
/** @hidden */

export var groupCollapse = 'group-collapse';
/** @hidden */

export var beforeCheckboxRenderer = 'beforeCheckboxRenderer';
/** @hidden */

export var refreshHandlers = 'refreshResizeHandlers';
/** @hidden */

export var refreshFrozenColumns = 'refresh-frozen-columns';
/** @hidden */

export var setReorderDestinationElement = 'set-reorder-destination-element';
/** @hidden */

export var refreshVirtualFrozenHeight = 'refresh-virtual-frozen-height';
/** @hidden */

export var setFreezeSelection = 'set-freeze-selection';
/** @hidden */

export var setInfiniteFrozenHeight = 'set-infinite-frozen-height';
/** @hidden */

export var setInfiniteColFrozenHeight = 'set-infinite-col-frozen-height';
/** @hidden */

export var beforeRefreshOnDataChange = 'before-refresh-on-data-change';
/** @hidden */

export var immutableBatchCancel = 'immutable-batch-cancel';
/** @hidden */

export var refreshVirtualFrozenRows = 'refresh-virtual-frozenrows';
/** @hidden */

export var checkScrollReset = 'check-scroll-reset';
/** @hidden */

export var refreshFrozenHeight = 'refresh-frozen-height';
/** @hidden */

export var setHeightToFrozenElement = 'set-height-to-frozen-element';
/** @hidden */

export var preventFrozenScrollRefresh = 'prevent-frozen-scroll-refresh';
/** @hidden */

export var nextCellIndex = 'next-cell-index';
/** @hidden */

export var refreshInfiniteCurrentViewData = 'refresh-infinite-current-view-data';
/** @hidden */

export var infiniteCrudCancel = 'infinite-crud-cancel';
/** @hidden */

export var filterDialogClose = 'filter-dialog-close';
/** @hidden */

export var refreshCustomFilterOkBtn = 'refresh-cutsom-filter-ok-button';
/** @hidden */

export var refreshCustomFilterClearBtn = 'refresh-cutsom-filter-clear-button';
/** @hidden */

export var renderResponsiveCmenu = 'render-responsive-cmenu';
/** @hidden */

export var filterCmenuSelect = 'filter-cmenu-select';
/** @hidden */

export var customFilterClose = 'custom-filter-close';
/** @hidden */

export var setFullScreenDialog = 'set-fullscreen-dialog';
/** @hidden */

export var refreshVirtualCacheOnRowDD = 'refresh-Virtual-Cache-On-RowDD';
/** @hidden */

export var refreshExpandandCollapse = 'refresh-Expand-and-Collapse';
/** @hidden */

export var rowModeChange = 'row-mode-change';
/** @hidden */

export var enterKeyHandler = 'enter-key-handler';
/** @hidden */

export var refreshVirtualMaxPage = 'refresh-virtual-max-page';
/** @hidden */

export var selectRowOnContextOpen = 'select-row-on-context-open';
/** @hidden */

export var pagerRefresh = 'pager-refresh';
/** @hidden */

export var closeInline = 'closeinline';
/** @hidden */

export var closeBatch = 'closebatch';
/** @hidden */

export var closeEdit = 'close-edit';
/** @hidden */

export var resetVirtualFocus = 'reset-virtual-focus';
/** @hidden */

export var afterContentRender = 'after-content-renderer';